import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fill-envelope",
  "use": "fill-envelope-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"fill-envelope\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 4c0-1.244.758-2 2-2h12c1.242 0 2 .755 2 2v8c0 1.244-.758 2-2 2H2c-1.242 0-2-.755-2-2V4zm3.6.7a.5.5 0 01.7-.1L8 7.375 11.7 4.6a.5.5 0 01.6.8l-4 3a.5.5 0 01-.6 0l-4-3a.5.5 0 01-.1-.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol